<template>
  <b-overlay :show="transactionLoading" class="rounded" variant="transparent">
    <template #overlay>
      <b-img
        width="100"
        :src="require('@/assets/img/brand/loader.gif')"
        alt=""
      />
    </template>
    <div class="card shadow p-3">
      <div class="card-header border-0 bg-transparent">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0 bg-transparent">
              {{ title }}
            </h3>
          </div>
        </div>
      </div>
      <b-row>
        <b-col md="2">
          <b-form-select
            v-model="filter.per_page"
            :options="[5, 10, 20, 100]"
            @input="debouncedGetAnswer()"
            size="sm"
            class="mt-2"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
          <b-form-group>
            <b-input-group>
              <b-form-input
                class="form-control-sm"
                v-model="filter.search"
                type="search"
                :placeholder="$t('search')"
                @input="debouncedGetAnswer()"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="getTransactions ? getTransactions.data : []"
            :fields="columns"
            :per-page="getTransactions.per_page"
            :busy="
              getTransactions
                ? getTransactions.total == 0
                  ? true
                  : false
                : true
            "
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <span class="h2 text-danger">{{ $t("fail") }}</span>
              </div>
            </template>
            <template v-slot:cell(name)="data">
              <span v-if="data.item.user"
                >{{ data.item.user.name }} {{ data.item.user.lastname }}</span
              >
            </template>
            <template v-slot:cell(amount)="data">
              <span>{{ data.item.points }} MP</span>
            </template>
            <template v-slot:cell(created_at)="data">
              {{
                moment(data.item.created_at).format('DD-MM-YYYY')
              }} hrs.
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-if="getTransactions"
            v-model="filter.page"
            :total-rows="getTransactions.total"
            :per-page="getTransactions.per_page"
            :page-count="getTransactions.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import _ from "lodash";
import moment from 'moment'
export default {
  name: "visits-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.getData, 300);
    await this.getData();
  },
  data() {
    return {
      dataCategory: {},
      filter: {
        page: 1,
        per_page: 5,
        search: null,
      },
      moment
    };
  },
  methods: {
    ...mapActions({
      fetchTransactions: "fetchTransactions",
    }),
    async getData() {
      await this.fetchTransactions({
        company_id: this.$route.params.id,
        filter: this.filter,
      });
    },
    async changePage(value) {
      this.filter.page = value;
      this.debouncedGetAnswer();
    },
  },
  computed: {
    ...mapGetters({
      getTransactions: "getTransactions",
      getUser: "user",
      transactionLoading: "transactionLoading",
    }),
    columns() {
      return [
        {
          label: this.$t("concept"),
          key: "concept",
          class: "text-center",
        },
        {
          label: this.$t("amount"),
          key: "amount",
          class: "text-center",
        },
        { label: this.$t("date"), key: "created_at", class: "text-center" },
      ];
    },
  },
};
</script>